/**
 * Utilitaires pour la gestion des cookies
 */

/**
 * Établit un cookie
 * @param {string} name - Le nom du cookie
 * @param {string} value - La valeur du cookie
 * @param {number} days - Nombre de jours avant expiration (optionnel, par défaut 30 jours)
 */
export const setCookie = (name, value, days = 30) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/`;
};

/**
 * Récupère la valeur d'un cookie
 * @param {string} name - Le nom du cookie
 * @returns {string|null} La valeur du cookie ou null s'il n'existe pas
 */
export const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(nameEQ)) {
            return decodeURIComponent(cookie.substring(nameEQ.length));
        }
    }
    return null;
};

/**
 * Supprime un cookie
 * @param {string} name - Le nom du cookie à supprimer
 */
export const deleteCookie = (name) => {
    setCookie(name, '', -1);
};
